import { sendAjaxRequest } from "./comunicacion.js";

export function imputarFase(imputacion: Imputacion): Promise<ResponseMessage> {
	const url = "/api/v1/imputarFase";
	const data = {
		idOF: imputacion.idOF,
		idFase: imputacion.idFase,
		cantidadProducida: imputacion.cantProducida,
		ubicacionSalida: imputacion.ubicacion,
		contenedorSalida: imputacion.contenedor,
		fechaImputacion: imputacion.fechaImputacion,
		consumos: imputacion.consumos,
	};

	return sendAjaxRequest("POST", url, data);
}

export function cerrarFase(cierre: Cierre): Promise<ResponseMessage> {
	const url = "/api/v1/cerrarFase";
	const data = {
		idOF: cierre.idOF,
		idFase: cierre.idFase,
		fechaImputacion: cierre.fechaCierre
	};

	return sendAjaxRequest("POST", url, data);
}

export function cerrarOF(idOF: number): Promise<ResponseMessage> {
	const url = "/api/v1/cerrarOF";
	const data = {
		idOF: idOF,
	};

	return sendAjaxRequest("POST", url, data);
}

export function getImputacionesFase(idOF: number, idFase: number): Promise<ImputacionFase[]> {
	const url = "/api/v1/getImputacionesFase";
	const params = {
		idOF: idOF,
		idFase: idFase,
	};

	return sendAjaxRequest("GET", url, params);
}

export function iniciarFase(inicio: Inicio): Promise<ResponseMessage> {
	const url = "/api/v1/empezarFase";
	const data = {
		idOF: inicio.idOF,
		idFase: inicio.idFase,
		fechaImputacion: inicio.fechaInicio
	};

	return sendAjaxRequest("POST", url, data);
}




type ResponseMessage = ResponseSuccess | ResponseError;
interface ResponseError {
	message: string;
	status: "error";
}
interface ResponseSuccess {
	message: string;
	status: "success";
}


export interface InfoFaseExtra {
	idOF: number;
	idFase: number;
	descripcionFase: string;
	idPuesto: string;

	idArticulo: string;
	descripcionArticulo: string;

	cantAcabada: number;
	cantLanzada: number;
	cantRechazada: number;

	timestampFin: number | null;
	timestampIni: number | null;
}

export interface Imputacion {
	idOF: number;
	idFase: number;
	fechaImputacion: number;
	cantProducida: number;
	ubicacion: string | null;
	contenedor: number | null;
	consumos: ConsumoInput[];
}

export interface Cierre {
	idOF: number;
	idFase: number;
	fechaCierre: number;
}

export interface Inicio {
	idOF: number;
	idFase: number;
	fechaInicio: number;
}

export interface ConsumoInput {
	idArticulo: string | number;
	faseArticulo: number;
	loteArticulo: string | null;

	idUbicacion: string | null;
	idContenedor: number | null;

	cantidadUsada: number;
	cantidadDefectuosa: number;
	cantidadDesperdiciada: number;
}
export interface Consumo {
	idArticulo: string | number;
	referenciaArticulo: string;
	faseArticulo: number;
	loteArticulo: string | null;
	descripcion: string;

	idUbicacion: string | null;
	idContenedor: number | null;

	cantidadUsada: number;
	cantidadDefectuosa: number;
	cantidadDesperdiciada: number;
}

export interface DatosFabricando {
	idOF: number;
	descFase: string;
	textoOF: string;
	textoFase: string;
	idFase: number;
	idConjunto: string;
	descConjunto: string;
	lote: string;
	descMaquina: string;

	fases: Array<{
		idFase: number;
		descFase: string;
	}>;
	componentes: ComponenteOF[];

	cantAcabada: number;
	cantLanzada: number;
	cantRechazada: number;
	cantidadOF: number;

	timestampIni: number | null;
	timestampFin: number | null;
}
export interface ComponenteOF {
	idArticulo: string;
	fase: number;
	referencia: string;
	descripcion: string;
	checked: boolean;
	gestionaLotes: boolean;
	cantidadPorUnidad: number;
	stock: number;
	lotes: Array<{
		lote: string;
		cantidad: number;
	}>;
}

export interface ImputacionFase {
	cantidad: number;
	idOperario: string;
	nombreOperario: string;
	inicio: number | null;
	final: number | null;
	fecha_imputacion: number | null;
	consumos: Consumo[];
}